import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import LoadingOverlay from 'components/LoadingOverlay';
import Modal from 'components/Modal';
import history from 'routing/history';
import Rating from './Rating';
import ImprovementIdea from './ImprovementIdea';
import Thanks from './Thanks';
import { checkNPSSubmitted, sendNPS } from './state';
import { NPSContainer, Heading } from './styled';

const NPS = ({ product, productTitle, profilePath }) => {
  const dispatch = useDispatch();
  const { isLoading, error, npsSubmitted } = useSelector((state) => state.global.nps);
  const [step, setStep] = useState(0);
  const [rating, setRating] = useState(10);
  const [feedback, setFeedback] = useState('');
  const [hearAboutUs, setHearAboutUs] = useState('');
  const [suggestion, setSuggestion] = useState('');
  const [socialMediaPostUrl, setSocialMediaPostUrl] = useState('');
  const [showError, setShowError] = useState(false);

  const urlParams = new URLSearchParams(history.location.search);
  const campaign = urlParams.get('campaign');
  const claimId = urlParams.get('claimId');

  useEffect(() => {
    dispatch(checkNPSSubmitted(campaign, product, claimId));
  }, [dispatch, campaign, product, claimId]);

  const handleNextClick = () => setStep(step + 1);
  const handlePrevClick = () => setStep(step - 1);

  const sendAnswers = () => {
    dispatch(
      sendNPS({
        product,
        campaign: campaign || 'NONE',
        rating: Number(rating) || undefined,
        feedback,
        suggestion,
        hearAboutUs,
        socialMediaPostUrl,
        companyID: null,
        claimId: claimId || null,
        dateCompleted: new Date().toISOString()
      })
    );
  };

  useEffect(() => {
    if (error) setShowError(true);
  }, [error]);

  useEffect(() => {
    if (npsSubmitted) setStep(2);
  }, [npsSubmitted]);

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <ImprovementIdea
            productTitle={productTitle}
            onNextClick={() => sendAnswers()}
            onPrevClick={handlePrevClick}
            onSuggestionChange={(e) => setSuggestion(e.target.value)}
            onSocialMediaPostUrlChange={(e) => setSocialMediaPostUrl(e.target.value)}
            suggestion={suggestion}
            socialMediaPostUrl={socialMediaPostUrl}
            campaign={campaign}
            rating={Number(rating)}
          />
        );
      case 2:
        return <Thanks profilePath={profilePath} campaign={campaign} />;
      default:
        return (
          <Rating
            productTitle={productTitle}
            onNextClick={handleNextClick}
            onSubmit={() => {
              sendAnswers();
              setStep(step + 2);
            }}
            onRatingChange={(val) => setRating(val)}
            onFeedbackChange={(e) => setFeedback(e.target.value)}
            onHearAboutUsChange={(e) => setHearAboutUs(e.target.value)}
            rating={rating}
            feedback={feedback}
            hearAboutUs={hearAboutUs}
            campaign={campaign}
          />
        );
    }
  };
  return (
    <>
      <LoadingOverlay isLoading={isLoading} variant="light" />
      <NPSContainer bg="turquoise">
        <Modal header="Error" isOpen={showError} onClose={() => setShowError(false)}>
          Sending NPS could not be finished. You can submit feedback only once.
        </Modal>
        {step !== 2 && (
          <Heading>
            {campaign === 'claims_ni' ? 'Spread the word!' : 'Help us improve!'}
          </Heading>
        )}
        {renderStep()}
      </NPSContainer>
    </>
  );
};

NPS.propTypes = {
  product: PropTypes.string.isRequired,
  productTitle: PropTypes.string.isRequired,
  profilePath: PropTypes.string.isRequired
};

export default NPS;
